import { render } from "./SVGLoader.vue?vue&type=template&id=399d0112&scoped=true"
import script from "./SVGLoader.vue?vue&type=script&lang=js"
export * from "./SVGLoader.vue?vue&type=script&lang=js"

import "./SVGLoader.vue?vue&type=style&index=0&id=399d0112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399d0112"]])

export default __exports__